import * as DialogPrimitive from '@radix-ui/react-dialog'
import { cx } from 'class-variance-authority'
import { forwardRef, ReactNode } from 'react'
import Paragraph from './Paragraph'

const Root = DialogPrimitive.Root
const Close = DialogPrimitive.Close
const Trigger = DialogPrimitive.Trigger
const Description = DialogPrimitive.Description

type DialogContentProps = {
    title: string
    children: ReactNode
    className?: string
}

export const Content = forwardRef<HTMLDivElement, DialogContentProps>(
    ({ title, children, className, ...props }, forwardedRef) => (
        <DialogPrimitive.Portal>
            <DialogPrimitive.Overlay
                className="bg-overlay data-[state=open]:animate-overlayShow fixed inset-0"
                onClick={(e: any) => e.stopPropagation()}
            >
                <DialogPrimitive.Content
                    onClick={(e) => e.stopPropagation()}
                    ref={forwardedRef}
                    className={cx([
                        'data-[state=open]:animate-contentShow fixed top-[50%] left-[50%] max-h-[85vh] w-[90vw] translate-x-[-50%] translate-y-[-50%] rounded-3 bg-white focus:outline-hidden',
                        className
                    ])}
                    {...props}
                >
                    <DialogPrimitive.Title
                        asChild
                        className="rounded-tr-3 rounded-tl-3 bg-backgroundPrimary p-4 text-center"
                    >
                        <Paragraph size={5}>{title}</Paragraph>
                    </DialogPrimitive.Title>
                    <div className="overflow-visible">{children}</div>
                </DialogPrimitive.Content>
            </DialogPrimitive.Overlay>
        </DialogPrimitive.Portal>
    )
)

type DialogBodyProps = {
    children: ReactNode
    className?: string
}

const Body = ({ children, className }: DialogBodyProps) => {
    return (
        <div
            className={cx([
                'p-4 border-t border-b border-borderPrimary overflow-auto max-h-[calc(85vh-8.5rem)]',
                className
            ])}
        >
            {children}
        </div>
    )
}

type DialogFooterProps = {
    children: ReactNode
    className?: string
}

const Footer = ({ children, className }: DialogFooterProps) => {
    return <div className={cx(['p-3 grid grid-cols-2 gap-3 w-full', className])}>{children}</div>
}

export default { Root, Close, Trigger, Description, Content, Body, Footer }
